
import RequireAuthorization from "../components/Authorization"
import RootLayout from "../layouts/main/RootLayout"
import DashboardAppPage from "../pages/DashboardAppPage"
import UserManagement from "../pages/UserManagement"
import FirmwareUpgrade from "../pages/FirmwareUpgrade"
import DeviceManagement from "../pages/DeviceManagement"

const AdminRouters = {
  path: "/",
  element: <RootLayout />,
  children: [
    {
      path: "admin",
      element: <RequireAuthorization role={"admin"} key={"auth"} />,
      children: [
        {
          path: "dashboard",
          element: <DashboardAppPage />,
        },
        {
          path: "user-management",
          element: <UserManagement />,
        },
        {
          path: "device-management",
          element: <DeviceManagement />,
        },
        // {
        //   path: "upgrade",
        //   element: <FirmwareUpgrade />,
        // },
      ],
    },
  ],
}

export default AdminRouters